class VwHbsIslembolumtanimDTO {
    id?: number;
    fkTip?: number;
    adi?: string;
    ekleyenKullanici?: number;
    eklemeTarihi?: string;
    guncelleyenKullanici?: number;
    guncellemeTarihi?: string;
    tip?: string;
}
export default VwHbsIslembolumtanimDTO;